import {observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import _ from 'lodash';
import {withState, t} from 'shared/core';
import {Panel, ActionLink, EmojiTitle} from 'shared/components';
import {newTab, dayOfWeek} from 'shared/tools';
import {WhatsGoingOnState} from '../state';
import EventList from './EventList';

const Today = observer(({agenda}) => {
  return (
    <div className='WhatsGoingOn-column'>
      <div className='WhatsGoingOn-heading'>
        <FormattedMessage id='hr_dashboard.whats_going_on.Today'/>
      </div>
      {agenda.hasEvents ?
        <EventList agenda={agenda}/> :
        <Panel.EmptyState message='hr_dashboard.whats_going_on.Nothing on the calendar today'/>}
    </div>
  );
});

const Upcoming = observer(({agendas}) => {
  if (_.isEmpty(agendas)) {
    return (
      <div className='WhatsGoingOn-column WhatsGoingOn-column--upcoming'>
        <div className='WhatsGoingOn-heading'>
          <FormattedMessage id='hr_dashboard.whats_going_on.Upcoming'/>
        </div>
        <Panel.EmptyState
          message='hr_dashboard.whats_going_on.Nothing coming up in the next 7 days'
        />
      </div>
    );
  }

  return (
    <div className='WhatsGoingOn-column WhatsGoingOn-column--upcoming'>
      {agendas.map(agenda =>
        <div className='WhatsGoingOn-day' key={agenda.key}>
          <div className='WhatsGoingOn-heading'>{dayOfWeek(agenda.date)}</div>
          <EventList agenda={agenda}/>
        </div>
      )}
    </div>
  );
});

const WhatsGoingOn = observer(({uiState}) => {
  const {enabled, emojiReady, todaysAgenda, upcomingAgendas} = uiState;

  if (!enabled) return null;

  return (
    <Panel className='WhatsGoingOn max-width-screen-width'>
      <Panel.Header
        title={<EmojiTitle
          emojiReady={emojiReady}
          emojiKey='spiral_calendar_pad'
          title={t("hr_dashboard.whats_going_on.What's Going On")}
        />}
      >
        <ActionLink className='flex align-items-middle justify-end h4' onClick={() => newTab('/calendar')}>
          <i className='material-symbols-solid align-middle mr1 h3' style={{paddingBottom: 2}}>{'calendar_month'}</i>
          <FormattedMessage id='hr_dashboard.whats_going_on.Calendar'/>
        </ActionLink>
      </Panel.Header>
      <div className='WhatsGoingOn-columns'>
        <Today agenda={todaysAgenda}/>
        <Upcoming agendas={upcomingAgendas}/>
      </div>
    </Panel>
  );
});

export default withState(WhatsGoingOn, WhatsGoingOnState);
